module.exports = __webpack_public_path__ + "static/media/register.51d4e1c5.jpg";